import { axiosGet } from "../../Helpers";

export const loadLookupsList = async (setLoading) => {
  setLoading(true);
  const response = await axiosGet("lookup/listLookup");
  setLoading(false);

  const data = response.data?.data;

  return data;
};
export const loadLookupsTypes = async (setLoading) => {
  setLoading(true);
  const response = await axiosGet("lookup/distinctLookup");
  setLoading(false);
  const data = response.data?.data;

  return data;
};
